"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Links = void 0;
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../../context/navigation");
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _utils = require("../../../utils");
var _Skeleton = require("../../Skeleton");
var _constants = require("../constants");
var _BurgerMenuLink = require("./BurgerMenuLink");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LazyFavorites = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_Favorites" */'../Favorites/Favorites')))).Favorites
}));
const LazyOurStory = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_OurStory" */'../OurStory/OurStory')))).OurStory
}));
const Links = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    activeLink,
    toggleActiveLink
  } = (0, _navigation.useActiveLink)();
  const {
    shopSectionItems: items,
    loadingShopSectionItems: loading
  } = (0, _navigation.useBurgerMenu)();
  const isMobile = (0, _hooks.useIsMobile)();
  const showFavorites = !isAnonymousUser && isMobile;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const analyticsData = (0, _react.useCallback)(
  // istanbul ignore next -- do not need to test on click event
  url => () => {
    (0, _utils.logUserClick)(url);
  }, []);
  (0, _react.useEffect)(() => {
    if (!activeLink) {
      const catalogueSection = items.find(x => x.linkType === 'Catalogue');
      if (catalogueSection) {
        toggleActiveLink(catalogueSection);
      }
    }
  }, [activeLink, items, toggleActiveLink]);

  // eslint-disable-next-line react-compiler/react-compiler -- We need this.
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Should clear active link only once on close
  (0, _react.useEffect)(() => () => toggleActiveLink(null), []);
  if (loading || items.length === 0) {
    return isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonMainCategoriesMobile, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonMainCategoriesDesktop, {});
  }
  const {
    orderedCommonLinks,
    orderedSpecialLinks,
    topLinks
  } = (0, _utils2.getOrderedLinks)(items);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductsNav, {
    "aria-label": `${translations.menu} - ${translations.products}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LinksRoot, {
      "data-testid": getTestId(_constants.LINKS_ROOT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        children: showFavorites ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyFavorites, {}) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuSectionDivider, {
        children: topLinks.map(link => /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuLink.BurgerMenuLink, {
          link: link
        }, link.id))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuSectionDivider, {
        children: orderedCommonLinks.map(link => /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuLink.BurgerMenuLink, {
          link: link
        }, link.id))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SpecialLinkWrapper, {
        "data-testid": getTestId(_constants.SPECIAL_LINKS_WRAPPER),
        children: orderedSpecialLinks.map(link => link.url && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinksSpecialLink, {
          href: link.url,
          "data-testid": getTestId(_constants.SPECIAL_LINK),
          onClick: analyticsData(link.url),
          children: link.title
        }, link.id))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        children: isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyOurStory, {}) : null
      })]
    })
  });
};
exports.Links = Links;
var _default = exports.default = Links;
